
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ClientReportType enum
 */
class ClientReportType {
  /**
   * Initialize enum with a given value
   * @param {ClientReportType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ClientReportType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ClientReportType}
   * @param {!ClientReportType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ClientReportType)) {
      throw new TypeError('Instance of ClientReportType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ClientReportType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ClientReportType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ClientReportType.UNKNOWN.value) {
      return 'UNKNOWN'
    }
    if (this.value === ClientReportType.DAILY_CONFIRMATION.value) {
      return 'DAILY_CONFIRMATION'
    }
    if (this.value === ClientReportType.MONTHLY_STATEMENT.value) {
      return 'MONTHLY_STATEMENT'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ClientReportType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ClientReportType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ClientReportType} Created enum
   */
  static fromObject (other) {
    return new ClientReportType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ClientReportType.UNKNOWN = new ClientReportType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
ClientReportType.DAILY_CONFIRMATION = new ClientReportType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
ClientReportType.MONTHLY_STATEMENT = new ClientReportType(0 + 2)

export { ClientReportType };

/**
 * Fast Binary Encoding ClientReportType field model
 */
class FieldModelClientReportType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelClientReportType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelClientReportType}
   * @param {ClientReportType=} defaults Default value, defaults is new ClientReportType()
   * @returns {!ClientReportType} Result value
   */
  get (defaults = new ClientReportType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ClientReportType(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelClientReportType}
   * @param {!ClientReportType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelClientReportType };
